if (!customElements.get('balance-cards-slider')) {
  customElements.define(
    'balance-cards-slider',
    class BalanceCardsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.balance-cards__track');
        this.prevButton = this.querySelector('.balance-cards__arrow--prev');
        this.nextButton = this.querySelector('.balance-cards__arrow--next');

        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.update = this.update.bind(this);
        this.showPrevious = this.showPrevious.bind(this);
        this.showNext = this.showNext.bind(this);

        this.prevButton.addEventListener('click', this.showPrevious);
        this.nextButton.addEventListener('click', this.showNext);
        this.track.addEventListener('scroll', this.update, { passive: true });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.prevButton) this.prevButton.removeEventListener('click', this.showPrevious);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.showNext);
        if (this.track) this.track.removeEventListener('scroll', this.update);
      }

      getScrollDistance() {
        const card = this.track.querySelector('.balance-cards__item');
        if (!card) return this.track.clientWidth;

        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      showPrevious() {
        this.track.scrollBy({ left: -this.getScrollDistance(), behavior: 'smooth' });
      }

      showNext() {
        this.track.scrollBy({ left: this.getScrollDistance(), behavior: 'smooth' });
      }

      update() {
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
        const isAtStart = this.track.scrollLeft <= 2;
        const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;

        this.prevButton.hidden = !hasOverflow || isAtStart;
        this.nextButton.hidden = !hasOverflow || isAtEnd;
      }
    }
  );
}
